import { Button } from '@shared/components/ui/button';
import { FilterConditionOutput } from '@components/ui/AdvancedFilter';
import { faFileArrowDown, faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useExportOrdersWithoutWeight } from '../../hooks/useExportOrdersWithoutWeight';
import type { AgGridTableProps } from '@shared/components/ui/AgGridTable';

type SortingConfig = NonNullable<AgGridTableProps['sorting']>;

interface Props {
  filterConditions: FilterConditionOutput[];
  sorting?: SortingConfig | null;
  visibleColumns?: string[];
}

export const DownloadExcelButton: React.FC<Props> = ({ filterConditions, sorting, visibleColumns }) => {
  const { t } = useTranslation('ordersWithoutWeightModule');
  const { exportOrdersWithoutWeight, isExporting } = useExportOrdersWithoutWeight();

  const handleExport = () => {
    exportOrdersWithoutWeight(filterConditions, sorting || null, visibleColumns);
  };

  return (
    <Button
      onClick={handleExport}
      disabled={isExporting}
      type="button"
      size="sm"
      variant="outline"
      className="!py-[9px] !px-2 text-foreground/70 hover:text-foreground border-input hover:bg-accent"
      data-testid="export-excel-button"
    >
      {isExporting ? (
        <FontAwesomeIcon icon={faSpinnerThird} className="animate-spin" />
      ) : (
        <FontAwesomeIcon icon={faFileArrowDown} />
      )}
    </Button>
  );
};
